function Footer() {
  return (
    <div
      style={{
        background: "#152543",
        fontFamily: "Roboto",
        fontSize: "12px",
        color: "#D9D9D9",
        height: "50px",
        display: "flex",
        padding: "10px 0px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          justifyItems: "center",
        }}
      >
        <div>
          This material may not be published, broadcast, rewritten, or
          redistributed.
        </div>
        <div>©2025 FLAT News LLC. All rights reserved</div>
      </div>
    </div>
  );
}

export default Footer;
